import React from 'react'
import tw from 'tailwind-styled-components'

const TwContainer = tw.div`
  flex
  items-center
`

const TwSeparator = tw.span`
  mx-4
  text-sm-regular
  color-primary
  w-16
  h-16
  text-center
`

const TwEnd = tw.div`
  flex
  align-center
  ml-12
`

export interface ChainProps {
  children: React.ReactNode
  separator?: React.ReactNode
  end?: React.ReactNode
}

export interface ChainStepProps {
  disabled?: boolean
  // Если children - функция, то ей будет передан флаг disabled.
  children: React.ReactNode | ((props: {disabled: boolean}) => React.ReactNode)
}

const ChainStep: React.FC<ChainStepProps> = ({disabled = false, children}) => {
  return (
    <div>
      {typeof children === 'function' ? children({disabled}) : children}
    </div>
  )
}

const Chain: React.FC<ChainProps> & {Step: React.FC<ChainStepProps>} = ({
  children,
  separator,
  end
}) => {
  const childrenArray = React.Children.toArray(children)

  return (
    <TwContainer>
      {childrenArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < childrenArray.length - 1 &&
            (separator ? separator : <TwSeparator>»</TwSeparator>)}
        </React.Fragment>
      ))}
      {end && <TwEnd>{end}</TwEnd>}
    </TwContainer>
  )
}

// Прикрепляем Chain.Step к Chain
Chain.Step = ChainStep

export default Chain
